export default __webpack_public_path__ + "static/media/checkbox-checked.91574068.svg";